import { useEffect } from 'react';

import { Routes } from 'core/domains/settings';
import { hasAccessToken } from 'core/middlewares/effects/orchestrator/workflows/getters/getters';
import { useRouteSettings } from 'core/use-cases/settings/hooks';
import { useNavigate } from 'react-router';

export const useLogoutApplicationWrapper = () => {
  const { isPrivate } = useRouteSettings() as Routes;

  const navigate = useNavigate();

  useEffect(() => {
    if (!hasAccessToken() && isPrivate) {
      navigate('/logout');
    }
  }, [hasAccessToken(), isPrivate]);
};
